export const getBillingTypeCodeMapping = (billingTypeCode) => {
  if (!billingTypeCode) return "";
  const fixedBillingType = billingTypeCode?.toString().padStart(2, "0"); // Change 1-9 to 01-09
  switch (fixedBillingType) {
    case "01":
      return "Notice billing";
    case "02":
      return "Bank Draft";
    case "05":
      return "Group Bill";
    case "06":
      return "Credit Card";
    case "07":
      return "No Bill ";
    case "08":
      return "Waiver of Premium-Temporary";
    case "09":
      return "Waiver of Premium-Permanent";
    case "10":
      return "Payor Death Waiver";
    default:
      return "";
  }
};
